interface SnapshotTiming {
  fromCache: boolean;
  resultCount: number;
}

interface StartupTimingDetails {
  failed?: boolean;
  fromCache?: boolean;
  resultCount?: number;
  signedIn?: boolean;
}

export const logStartupTiming = (
  label: string,
  startedAt: number,
  details: StartupTimingDetails = {},
) => {
  if (!import.meta.env.DEV) return;

  console.info(`[startup] ${label}`, {
    durationMs: Math.round(performance.now() - startedAt),
    ...details,
  });
};

export const createStartupSnapshotLogger = (label: string) => {
  const startedAt = import.meta.env.DEV ? performance.now() : 0;
  let firstSnapshotLogged = false;
  let firstServerSnapshotLogged = false;

  return ({ fromCache, resultCount }: SnapshotTiming) => {
    if (!import.meta.env.DEV) return;

    const details = {
      durationMs: Math.round(performance.now() - startedAt),
      fromCache,
      resultCount,
    };

    if (!firstSnapshotLogged) {
      console.info(`[startup] ${label} first snapshot`, details);
      firstSnapshotLogged = true;
      if (!fromCache) firstServerSnapshotLogged = true;
    }

    if (fromCache || firstServerSnapshotLogged) return;

    console.info(`[startup] ${label} first server snapshot`, details);
    firstServerSnapshotLogged = true;
  };
};

export const STARTUP_STARTED_AT = import.meta.env.DEV ? performance.now() : 0;
